(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-barefoot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-barefoot')) {
    customElements.define('bw-barefoot', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.controller = null;
      }

      init() {
        if (!this.isConnected || this.controller) return;
        this.items = Array.from(this.querySelectorAll('[data-bwbf-item]'));
        if (!this.items.length) return;
        this.frames = Array.from(this.querySelectorAll('[data-bwbf-frame]'));
        this.triggers = Array.from(this.querySelectorAll('[data-bwbf-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-bwbf-panel]'));
        this.dots = Array.from(this.querySelectorAll('[data-bwbf-dot]'));
        this.status = this.querySelector('[data-bwbf-status]');
        this.mobile = matchMedia('(max-width: 989px)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.active = Math.min(this.active || 0, this.items.length - 1);
        this.toggleAttribute('data-multiple', this.items.length > 1);

        this.triggers.forEach((button, index) => {
          button.addEventListener('click', () => this.show(index), options);
        });
        this.dots.forEach((button, index) => {
          button.addEventListener('click', () => this.show(index, true), options);
        });
        this.querySelector('[data-bwbf-prev]').addEventListener('click', () => this.show(this.active - 1, true), options);
        this.querySelector('[data-bwbf-next]').addEventListener('click', () => this.show(this.active + 1, true), options);
        this.mobile.addEventListener('change', () => this.show(this.active), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.show(index);
        }, options);

        const viewport = this.querySelector('[data-bwbf-items]');
        viewport.addEventListener('pointerdown', (event) => {
          this.pointerStart = null;
          if (!this.mobile.matches || !event.isPrimary || event.button !== 0 || event.target.closest('a, button, input, textarea, select')) return;
          this.pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        viewport.addEventListener('pointerup', (event) => {
          const start = this.pointerStart;
          this.pointerStart = null;
          if (!this.mobile.matches || !start || event.pointerId !== start.id) return;
          const x = event.clientX - start.x;
          const y = event.clientY - start.y;
          if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.3) {
            this.show(this.active + (x < 0 ? 1 : -1), true);
          }
        }, options);
        viewport.addEventListener('pointercancel', () => { this.pointerStart = null; }, options);
        this.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !event.target.closest('[data-bwbf-dot], [data-bwbf-prev], [data-bwbf-next]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.active + (event.key === 'ArrowRight' ? 1 : -1), true);
          this.dots[this.active].focus({ preventScroll: true });
        }, options);
        this.setAttribute('data-ready', '');
        this.show(this.active);
      }

      show(index, announce = false) {
        this.active = (index + this.items.length) % this.items.length;
        const mobile = this.mobile.matches;
        const focused = document.activeElement;
        let restoreFocus = false;
        this.items.forEach((item, i) => {
          const selected = i === this.active;
          if (item.contains(focused) && ((!selected && mobile) || (mobile && focused === this.triggers[i]) || (!mobile && !selected && this.panels[i].contains(focused)))) {
            restoreFocus = true;
          }
          item.classList.toggle('is-active', selected);
          item.inert = mobile && !selected;
          if (mobile && !selected) item.setAttribute('aria-hidden', 'true');
          else item.removeAttribute('aria-hidden');
          this.panels[i].hidden = !mobile && !selected;
          this.triggers[i].setAttribute('aria-expanded', String(mobile || selected));
          this.dots[i].setAttribute('aria-current', String(selected));
        });
        this.updateImage(this.active);
        if (restoreFocus) {
          const target = mobile ? this.items[this.active].querySelector('.bwbf__static-title') : this.triggers[this.active];
          if (mobile) target.tabIndex = -1;
          target.focus({ preventScroll: true });
        }
        if (announce) this.status.textContent = `${this.active + 1} de ${this.items.length}: ${this.items[this.active].dataset.title}`;
      }

      updateImage(index) {
        const frame = this.frames[index];
        const template = frame.querySelector('template');
        if (template) template.replaceWith(template.content.cloneNode(true));
        const image = frame.querySelector('img');
        // La foto anterior se mantiene visible mientras carga la nueva.
        const reveal = () => {
          if (!this.isConnected || this.active !== index) return;
          this.frames.forEach((item, i) => {
            item.classList.toggle('is-active', i === index);
            item.setAttribute('aria-hidden', String(i !== index));
          });
        };
        if (!image || (image.complete && image.naturalWidth > 0)) reveal();
        else if (!image.complete) image.addEventListener('load', reveal, { once: true, signal: this.controller.signal });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
